module.exports = __webpack_public_path__ + "img/gree-logo.e92e253c.png";